/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react';
import { styled } from '@mui/system';
import * as dates from '@simplybenefits/sb-dates';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import { ArrowBack as ArrowBackIcon, FolderOutlined as FolderOutlinedIcon, DescriptionOutlined as DescriptionOutlinedIcon, PictureAsPdfOutlined as PictureAsPdfOutlinedIcon, ImageOutlined as ImageOutlinedIcon, LockOutlined as LockOutlinedIcon, Visibility as VisibilityIcon, Download, MoreVert, DeleteForever } from '@mui/icons-material';
import Text from "../../components/Text.js";
import Button from "../../components/Button.js";
import Modal from '../../components/Modals/Modal.js';
import TextInput from "../../components/TextFields/TextInput.js";
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
import Loader from '../../components/Loader';
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1
});

/**
 * @param type
 * @param id
 * @param parentFolder
 * @param listFiles
 * @param uploadFile
 * @param downloadFile
 * @param makePrivate
 * @param makePublic
 * @param createFolder
 * @param removeFile
 * @param dispatch
 * @param isMasterSite
 * @param loader
 * @param whitelabel
 * @param isLocked
 * @param noContainer
 * @param style
 * @returns {JSX.Element}
 * @constructor
 */
const Files = ({
  type,
  id,
  parentFolder,
  listFiles,
  uploadFile,
  downloadFile,
  makePrivate,
  makePublic,
  createFolder,
  removeFile,
  dispatch,
  isMasterSite,
  loader,
  whitelabel,
  isLocked = false,
  noContainer = false,
  style = {},
  disableCreateFolder = false,
  skipNotification = false
}) => {
  const styles = {
    container: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      boxShadow: noContainer ? null : 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
      padding: noContainer ? 0 : "20px 30px",
      minHeight: 150,
      background: '#FFF',
      borderRadius: 10,
      ...style
    },
    headerContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      height: 50,
      width: '100%'
    },
    filenameContainer: {
      cursor: 'pointer',
      padding: disableCreateFolder ? "0px 0px 0px 0px" : null
    },
    breadcrumbContainer: {
      flex: 1
    }
  };
  const [files, setFiles] = useState([]);
  const [folders, setFolders] = useState([]);
  const [parentPath, setparentPath] = useState("/");
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [createFolderOpen, toggleCreateFolder] = useState(false);
  const [folderName, setFolderName] = useState(null);
  const [fileToDelete, setFileToDelete] = useState(null);
  const [openedMenu, setOpenedMenu] = useState(null);

  /**
   */
  const clearFiles = () => {
    setparentPath('/');
    setBreadcrumbs([]);
  };

  /**
   * @param path
   * @returns {Promise<void>}
   */
  const selectFolder = async path => {
    const temp = path.split('/');
    await setBreadcrumbs([...breadcrumbs, {
      title: temp[temp.length - 2],
      path
    }]);
    setparentPath(path);
  };

  /**
   * @returns {Promise<void>}
   */
  const goBack = () => {
    const currentBreadcrumbs = [...breadcrumbs];
    const nextState = currentBreadcrumbs[currentBreadcrumbs.length - 2];
    currentBreadcrumbs.splice(currentBreadcrumbs.length - 1, 1);
    setparentPath(nextState ? nextState.path : '/');
    setBreadcrumbs(currentBreadcrumbs);
  };

  /**
   * @param breadcrumb
   * @returns {Promise<void>}
   */
  const selectBreadcrumb = breadcrumb => {
    // find the selected breadcrumb in the list of past paths
    const index = breadcrumbs.findIndex(obj => obj.title === breadcrumb.title);

    // set the new parent directory to the selected breadcrumb path
    setparentPath(breadcrumbs[index].path);

    // remove all breadcrumbs after the selected breadcrumb
    breadcrumbs.splice(index + 1, breadcrumbs.length - index - 1);

    // set the new breadcrumbs on the page
    setBreadcrumbs(breadcrumbs);
  };

  /**
   * @returns {Promise<void>}
   */
  const listDirectory = async () => {
    let path = null;
    if (parentPath !== '/') {
      path = parentPath.split(`${id}/${parentFolder}/`)[1];
    }
    const data = await dispatch(listFiles(type, id, parentFolder, path));
    setFiles(data.files);
    setFolders(data.folders);
  };

  /**
   * @param event
   * @returns {Promise<void>}
   * @private
   */
  const _handleFileUpload = async event => {
    const file = event.target.files[0];
    if (!file) {
      console.log("No file selected.");
      return;
    }
    const success = await dispatch(uploadFile(type, id, parentFolder, file, parentPath === '/' ? null : parentPath, skipNotification));
    if (success) {
      listDirectory();
    }
  };

  /**
   * @param path
   * @returns {Promise<void>}
   * @private
   */
  const _downloadFile = async path => {
    const url = await dispatch(downloadFile(type, id, parentFolder, path));
    window.open(url, "_blank");
  };

  /**
   * @param path
   * @returns {Promise<void>}
   * @private
   */
  const _makePrivate = async path => {
    const success = await dispatch(makePrivate(type, id, path));
    if (success) {
      listDirectory();
    }
  };

  /**
   * @param path
   * @returns {Promise<void>}
   * @private
   */
  const _makePublic = async path => {
    const success = await dispatch(makePublic(type, id, path));
    if (success) {
      listDirectory();
    }
  };

  /**
   * @param items
   * @returns {*}
   * @private
   */
  const _sortFolders = items => {
    items.sort((a, b) => {
      const aSegments = a.Prefix.split('/');
      const aName = aSegments[aSegments.length - 2];
      const bSegments = b.Prefix.split('/');
      const bName = bSegments[bSegments.length - 2];
      return aName.localeCompare(bName);
    });
    return items;
  };

  /**
   * @param items
   * @returns {*}
   * @private
   */
  const _sortFiles = items => {
    items.sort((a, b) => {
      // Convert date strings to Date objects to compare
      let dateA = new Date(a.LastModified);
      let dateB = new Date(b.LastModified);
      return dateB - dateA; // for descending order
    });
    return items;
  };

  /**
   * @param string
   * @returns {string}
   * @private
   */
  const _capitalizeFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1);

  // list the parent directory on load
  useEffect(() => {
    listDirectory();
  }, [id, parentPath]);
  return /*#__PURE__*/React.createElement("div", {
    id: `${type}-files`,
    style: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.headerContainer
  }, breadcrumbs.length > 0 && /*#__PURE__*/React.createElement(IconButton, {
    variant: "plain",
    onClick: goBack
  }, /*#__PURE__*/React.createElement(ArrowBackIcon, {
    sx: {
      fontSize: 18
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: styles.breadcrumbContainer
  }, breadcrumbs.length === 0 ? /*#__PURE__*/React.createElement(Breadcrumbs, {
    "aria-label": "breadcrumbs",
    sx: {
      padding: 0,
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    mediumLarge: true,
    bold: true
  }, i18n.t(tokens.titles.files))) : /*#__PURE__*/React.createElement(Breadcrumbs, {
    "aria-label": "breadcrumbs",
    sx: {
      padding: 0,
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement(Link, {
    onClick: clearFiles,
    style: {
      textDecoration: 'none'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    mediumLarge: true,
    light: true
  }, i18n.t(tokens.titles.files))), breadcrumbs.map((item, i) => {
    if (i === breadcrumbs.length - 1) {
      return null;
    }
    return /*#__PURE__*/React.createElement(Link, {
      key: item.title,
      onClick: () => selectBreadcrumb(item),
      style: {
        textDecoration: 'none'
      }
    }, /*#__PURE__*/React.createElement(Text, {
      mediumLarge: true,
      light: true
    }, item.title));
  }), /*#__PURE__*/React.createElement(Text, {
    mediumLarge: true,
    bold: true
  }, breadcrumbs[breadcrumbs.length - 1].title))), !isLocked && /*#__PURE__*/React.createElement(React.Fragment, null, !disableCreateFolder && /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    color: "primary",
    onClick: () => toggleCreateFolder(true),
    customStyle: {
      marginRight: "10px"
    }
  }, i18n.t(tokens.buttons.createFolder)), /*#__PURE__*/React.createElement(Button, {
    primary: true,
    color: "primary",
    component: "label"
  }, i18n.t(tokens.buttons.uploadFile), /*#__PURE__*/React.createElement(VisuallyHiddenInput, {
    type: "file",
    id: "fileInput",
    name: "file",
    onChange: _handleFileUpload
  })))), /*#__PURE__*/React.createElement(Table, {
    hoverRow: true,
    sx: {
      marginTop: "20px"
    }
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    align: "left",
    sx: {
      fontWeight: 'bold'
    }
  }, i18n.t(tokens.labels.files.tableHeadings.name)), /*#__PURE__*/React.createElement(TableCell, {
    align: "center",
    sx: {
      fontWeight: 'bold'
    }
  }, i18n.t(tokens.labels.files.tableHeadings.owner)), /*#__PURE__*/React.createElement(TableCell, {
    align: "center",
    sx: {
      fontWeight: 'bold'
    }
  }, i18n.t(tokens.labels.files.tableHeadings.lastModified)), /*#__PURE__*/React.createElement(TableCell, {
    align: "center",
    sx: {
      fontWeight: 'bold'
    }
  }, i18n.t(tokens.labels.files.tableHeadings.fileSize)), /*#__PURE__*/React.createElement(TableCell, null))), /*#__PURE__*/React.createElement(TableBody, null, _sortFolders(folders).map(folder => {
    const pathSegments = folder.Prefix.split('/');
    const name = pathSegments[pathSegments.length - 2];
    const createdBy = "-";
    const lastModified = "-";
    const fileSize = "-";
    return /*#__PURE__*/React.createElement(TableRow, {
      key: folder.Prefix,
      onClick: () => selectFolder(folder.Prefix)
    }, /*#__PURE__*/React.createElement(TableCell, {
      align: "left",
      sx: styles.filenameContainer
    }, /*#__PURE__*/React.createElement(FolderOutlinedIcon, {
      sx: {
        marginRight: "10px",
        verticalAlign: 'bottom'
      }
    }), name), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, createdBy), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, lastModified), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, fileSize), /*#__PURE__*/React.createElement(TableCell, null));
  }), _sortFiles(files).map(file => {
    const isPrivate = file.accesstype === 'private';
    if (file.Size === 0) {
      return null;
    }

    // if the file is marked as private and we are on the master site then hide the file
    if (isPrivate && !isMasterSite) {
      return null;
    }
    const pathSegments = file.Key.split('/');
    const name = pathSegments[pathSegments.length - 1];
    const lastModified = dates.getLocalDisplay(file.LastModified, 'lll', i18n.locale);
    let kilobytes = Math.ceil(file.Size / 1024);
    let megabytes = (Number(file.Size) / (1024 * 1024)).toFixed(1);
    let owner = file.createdby ? _capitalizeFirstLetter(file.createdby.split('-')[0]) : '-';
    if (isPrivate && isMasterSite) {
      owner = `${owner} (Private)`;
    }
    const ext = name.split('.')[1];
    let icon = /*#__PURE__*/React.createElement(DescriptionOutlinedIcon, {
      sx: {
        marginRight: "10px",
        verticalAlign: 'bottom'
      }
    });
    if (ext && ext.toLowerCase() === 'pdf') {
      icon = /*#__PURE__*/React.createElement(PictureAsPdfOutlinedIcon, {
        sx: {
          marginRight: "10px",
          verticalAlign: 'bottom'
        }
      });
    } else if (ext && ['png', 'jpg', 'jpeg', 'gif'].includes(ext.toLowerCase())) {
      icon = /*#__PURE__*/React.createElement(ImageOutlinedIcon, {
        sx: {
          marginRight: "10px",
          verticalAlign: 'bottom'
        }
      });
    }
    const ownerDisplay = isMasterSite ? owner : owner.split(" ")[0];
    return /*#__PURE__*/React.createElement(TableRow, {
      key: file.key
    }, /*#__PURE__*/React.createElement(TableCell, {
      align: "left",
      sx: styles.filenameContainer,
      onClick: () => _downloadFile(file.Key)
    }, icon, name), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, isMasterSite ? ownerDisplay : i18n.t(tokens.labels.files.owners[ownerDisplay.toLowerCase()])), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, lastModified), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, megabytes >= 1 ? `${megabytes} MB` : `${kilobytes} KB`), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, /*#__PURE__*/React.createElement(IconButton, {
      id: `menu-button-${file.Key}`,
      "aria-controls": openedMenu === file.Key ? `menu-${file.Key}` : undefined,
      "aria-haspopup": "true",
      onClick: () => setOpenedMenu(openedMenu === file.Key ? null : file.Key)
    }, /*#__PURE__*/React.createElement(MoreVert, null)), /*#__PURE__*/React.createElement(Menu, {
      id: `menu-${file.Key}`,
      anchorEl: document.getElementById(`menu-button-${file.Key}`),
      open: openedMenu === file.Key,
      onClose: () => setOpenedMenu(null),
      MenuListProps: {
        'aria-labelledby': `menu-button-${file.Key}`
      }
    }, /*#__PURE__*/React.createElement(MenuItem, {
      onClick: () => {
        setOpenedMenu(null);
        _downloadFile(file.Key);
      }
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(Download, null)), ' ', i18n.t(tokens.labels.files.menu.open)), Boolean(parentFolder.toUpperCase().includes('PUBLIC') || parentFolder.toUpperCase().includes('PRIVATE')) && /*#__PURE__*/React.createElement(React.Fragment, null, isMasterSite && isPrivate && /*#__PURE__*/React.createElement(MenuItem, {
      onClick: () => {
        setOpenedMenu(null);
        _makePublic(file.Key);
      }
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(VisibilityIcon, null)), ' ', "Make Public"), isMasterSite && !isPrivate && /*#__PURE__*/React.createElement(MenuItem, {
      onClick: () => {
        setOpenedMenu(null);
        _makePrivate(file.Key);
      }
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(LockOutlinedIcon, null)), ' ', "Make Private")), !isLocked && /*#__PURE__*/React.createElement(MenuItem, {
      onClick: () => {
        setOpenedMenu(null);
        setFileToDelete(file.Key);
      }
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(DeleteForever, null)), ' ', i18n.t(tokens.labels.files.menu.delete)))));
  }))), /*#__PURE__*/React.createElement(Modal, {
    title: i18n.t(tokens.titles.areYouSure),
    small: true,
    loader: loader,
    open: fileToDelete,
    onClose: () => setFileToDelete(null),
    primaryButton: {
      label: i18n.t(tokens.labels.files.menu.delete),
      color: "error",
      onClick: async () => {
        const success = await dispatch(removeFile(type, id, parentFolder, fileToDelete));
        if (success) {
          setFileToDelete(null);
          listDirectory();
        }
      }
    }
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true
  }, i18n.t(tokens.labels.files.deleteMessage))), /*#__PURE__*/React.createElement(Modal, {
    title: i18n.t(tokens.buttons.createFolder),
    small: true,
    loader: loader,
    open: createFolderOpen,
    onClose: () => toggleCreateFolder(false),
    primaryButton: {
      label: i18n.t(tokens.buttons.create),
      onClick: async () => {
        const success = await dispatch(createFolder(type, id, parentFolder, folderName, parentPath === '/' ? null : parentPath));
        if (success) {
          toggleCreateFolder(false);
          listDirectory();
        }
      }
    }
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: i18n.t(tokens.labels.files.inputs.folderName),
    value: folderName,
    onChange: e => setFolderName(e.target.value),
    variant: "outlined",
    fullWidth: true,
    autoFocus: true
  })), loader?.isLoading && loader?.type === 'container' && /*#__PURE__*/React.createElement(Loader, {
    isContainer: true
  }));
};
export default Files;